import React, { Component } from "react";
import _ from "lodash";
import {
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  SafeAreaView
} from "react-native";
import AsyncStorage from '@react-native-community/async-storage';

import { EmojiRating } from "../components";
import { getBaseUrl, setConsultation } from "../helpers/storage";
import { connect } from "react-redux";
import fonts from "../constants/fonts";

const REACTIONS = [
  {
    label: "Sangat Buruk",
    src: require("../assets/1a.png"),
    bigSrc: require("../assets/1.png")
  },
  {
    label: "Buruk",
    src: require("../assets/2a.png"),
    bigSrc: require("../assets/2.png")
  },
  {
    label: "Baik",
    src: require("../assets/3a.png"),
    bigSrc: require("../assets/3.png")
  },
  {
    label: "Sangat Baik",
    src: require("../assets/4a.png"),
    bigSrc: require("../assets/4.png")
  }
];

const styles = StyleSheet.create({
  avatar: {
    borderRadius: 30,
    height: 60,
    marginRight: 15,
    width: 60
  },
  container: {
    justifyContent: "center",
    padding: 10
  },
  nameContainer: {
    flex: 1,
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  name: {
    color: "#FFF",
    ...fonts.regular,
    fontSize: 20,
  },
  position: {
    color: "#FFF",
    ...fonts.light,
    fontSize: 16
  },
  profile: {
    alignItems: "center",
    flexDirection: "row",
    padding: 25
  },
  ratingContainer: {
    alignItems: "center",
    backgroundColor: "#FFF",
    borderRadius: 40,
    padding: 40
  },
  question: {
    color: "#808080",
    ...fonts.regular,
    fontSize: 20,
    textAlign: "center"
  },
  selectedValue: {
    ...fonts.bold,
    textTransform: "uppercase",
    fontSize: 30,
    marginTop: 30,
    textAlign: "center"
  },
  thanks: {
    ...fonts.regular,
    fontSize: 20,
    marginVertical: 10,
    textAlign: "center"
  },
  itemLabel: {
    ...fonts.regular,
    fontSize: 14,
    color: "#808080",
    textAlign: "center"
  },
  itemImage: {
    borderRadius: 72,
    height: 72,
    width: 72
  },
  item: {
    alignItems: "center",
    flex: 0.3,
    borderWidth: 1,
    padding: 2,
    margin: 2
  },
  itemContainer: {
    marginTop: 10
  },
  input: {
    ...fonts.regular,
    fontSize: 16,
    marginTop: 50,
    borderBottomColor: "#000000",
    borderBottomWidth: 1,
    paddingBottom: 5
  },
  inputError: {
    borderColor: "#FF0000",
    borderWidth: 1,
    borderBottomColor: "#FF0000"
  },
  button: {
    alignSelf: "center",
    borderRadius: 20,
    color: "#FFF",
    ...fonts.bold,
    fontSize: 18,
    backgroundColor: "#5DBE66",
    paddingVertical: 10,
    paddingHorizontal: 50,
    marginTop: 40
  },
  emoji: {
    width: 120,
    height: 120
  }
});

class RatingScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedRating: null,
      submitted: false,
      note: "",
      categories: [],
      selectedCategories: {},
      noteValid: true
    };
  }

  _handleSelected = selection => {
    this.setState({
      selectedRating: selection,
      selectedCategories: {},
      noteValid: true
    });
  };

  async fetchRating() {
    setConsultation(null);

    const token = this.props.token;

    const response = await fetch(getBaseUrl() + "info/rating-feedback", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const json = await response.json();

    this.setState({
      categories: json["data"]
    });
  }

  async rate() {
    const token = this.props.token;

    fetch(getBaseUrl() + "consultations/doctor-rating", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      method: "POST",
      body: JSON.stringify({
        trx_id: this.props.navigation.state.params.transactionId,
        rating_score: this.state.selectedRating.key + 1,
        rating_notes: this.state.note,
        feedbacks: Object.keys(this.state.selectedCategories)
      })
    });
    
    await AsyncStorage.removeItem('active_consultation');
    this.setState({
      submitted: true
    });
  }

  componentDidMount() {
    this.fetchRating();
  }

  componentWillUnmount() {
    clearTimeout(this.closeTimeoutId);
  }

  render() {
    let ratingContent;
    const { noteValid } = this.state;

    if (this.state.submitted) {
      ratingContent = (
        <>
          <Image
            style={styles.emoji}
            source={REACTIONS[this.state.selectedRating.key].bigSrc}
          />

          <Text
            style={[
              styles.selectedValue,
              { color: this.props.themeColors.primary }
            ]}
          >
            {this.state.selectedRating.value}
          </Text>

          <Text style={styles.thanks}>
            Terima kasih atas feedback yang diberikan
          </Text>
        </>
      );
    } else {
      let categories = _.reject(this.state.categories, item => {
        let filter;

        if (this.state.selectedRating) {
          if (this.state.selectedRating.key > 1) {
            filter = "positive";
          } else {
            filter = "negative";
          }

          return item["feedback_category"] !== filter;
        } else {
          return true;
        }
      });

      ratingContent = (
        <>
          <Text style={styles.question}>
            Bagaimana pengalaman konsultasi Anda
          </Text>

          <EmojiRating
            onSelected={this._handleSelected}
            selected={this.state.selectedRating}
          />

          {this.state.selectedRating && (
            <View>
              <Text
                style={[
                  styles.selectedValue,
                  { color: this.props.themeColors.primary }
                ]}
              >
                {this.state.selectedRating.value}
              </Text>
              <Text style={styles.thanks}>
                Terima kasih, apa yang telah kami lakukan dengan{" "}
                {this.state.selectedRating.value.toLowerCase()}?
              </Text>
              <View style={styles.itemContainer}>
                {_.chunk(categories, 3).map((chunk, index) => {
                  return (
                    <View
                      key={index}
                      style={{
                        flexDirection: "row",
                        justifyContent: "center",
                        paddingVertical: 10
                      }}
                    >
                      {chunk.map(item => {
                        let customStyles = {
                          borderColor: "transparent"
                        };

                        if (this.state.selectedCategories[item["id"]]) {
                          customStyles = {
                            borderColor: "#5DBE66"
                          };
                        }

                        return (
                          <TouchableOpacity
                            style={[styles.item, customStyles]}
                            key={item["id"]}
                            onPress={() => {
                              const selectedCategories = Object.assign(
                                {},
                                this.state.selectedCategories
                              );

                              if (selectedCategories[item["id"]]) {
                                selectedCategories[
                                  item["id"]
                                ] = !selectedCategories[item["id"]];
                              } else {
                                selectedCategories[item["id"]] = true;
                              }

                              this.setState({
                                selectedCategories
                              });
                            }}
                          >
                            <Image
                              source={{
                                uri: item["feedback_photo"]
                              }}
                              style={[
                                styles.itemImage,
                                {
                                  backgroundColor: this.props.themeColors
                                    .lightestPrimary
                                }
                              ]}
                            />
                            <Text style={styles.itemLabel}>
                              {item["feedback_name"]}
                            </Text>
                          </TouchableOpacity>
                        );
                      })}
                    </View>
                  );
                })}
              </View>
              <TextInput
                style={[styles.input, noteValid ? {} : styles.inputError]}
                placeholder="Catatan"
                placeholderTextColor="#808080"
                onChangeText={note => this.setState({ note, noteValid: true })}
                value={this.state.note}
              />
              <TouchableOpacity
                onPress={() => {
                  // check required if rate <= 1
                  const { selectedRating, note } = this.state
                  const currentRating = selectedRating.key;
                  let noteValid = true;

                  if(currentRating <= 1 && !note) {
                    noteValid = false;
                  }

                  this.setState({
                    noteValid
                  }, () => {
                    const { noteValid } = this.state;
                    if(!noteValid) { return; }

                    this.rate();

                    this.closeTimeoutId = setTimeout(
                      () => this.props.navigation.goBack(),
                      3000
                    );
                  })
                }}
              >
                <Text style={styles.button}>Kirim</Text>
              </TouchableOpacity>
            </View>
          )}
        </>
      );
    }

    const profile = (
      <View style={styles.profile}>
        <Image
          source={
            this.props.navigation.state.params.agentAvatar
              ? {
                  uri: this.props.navigation.state.params.agentAvatar
                }
              : require("../assets/avatars/doctor.png")
          }
          style={styles.avatar}
        />
        <View style={styles.nameContainer}>
          <Text style={styles.name}>
            {this.props.navigation.state.params.agentName}
          </Text>
          {/* <Text style={styles.position}>
            {this.props.navigation.state.params.agentSpecialities}
          </Text> */}
        </View>
        <TouchableOpacity
          onPress={async () => {
            // user decided to skip rating, then remove from active consultation
            await AsyncStorage.removeItem('active_consultation');
            this.props.navigation.pop();
          }}
        >
          <View
            style={{
              marginStart: 15,
              backgroundColor: "#E64F4F",
              borderRadius: 10,
              paddingHorizontal: 10,
              paddingVertical: 10,
              borderColor: "#FFF",
              borderWidth: 2
            }}
          >
            <Image
              source={require("../assets/outline_close_white_24dp.png")}
            />
          </View>
        </TouchableOpacity>
      </View>
    );

    const rating = <View style={styles.ratingContainer}>{ratingContent}</View>;

    if (this.state.submitted || !this.state.selectedRating) {
      return (
        <View
          style={{
            backgroundColor: this.props.themeColors.primary,
            flex: 1,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <SafeAreaView style={styles.container}>
            {profile}
            {rating}
          </SafeAreaView>
        </View>
      );
    } else {
      return (
        <ScrollView
          style={{
            backgroundColor: this.props.themeColors.primary,
            flex: 1
          }}
        >
          <View style={styles.container}>
            {profile}
            {rating}
          </View>
        </ScrollView>
      );
    }
  }
}

export default connect(state => ({
  themeColors: state.themeColors,
  token: state.token
}))(RatingScreen);
